import { Box, Title, Text, ActionIcon, Button, Group, useMantineTheme, Stack, ScrollArea } from '@mantine/core';

import { Close } from '../../icons';

export interface ButtonProps {
  label: string
  disabled?: boolean
  onClick: () => void
  color?: string
};

interface Props {
  title?: string
  subtitle?: string
  children: React.ReactNode
  onClose?: () => void
  primaryButton?: ButtonProps
  secondaryButton?: ButtonProps
  leftSideButton?: ButtonProps
};

const ModalContent: React.FC<Props> = (props: Props) => {
  const {
    title, subtitle, children, onClose, primaryButton, secondaryButton, leftSideButton
  } = props;
  const { colors, other: colorVars } = useMantineTheme();

  const closeIcon = onClose !== undefined &&
    <ActionIcon variant='subtle' color={colorVars.primaryIconColor} onClick={onClose}>
      <Close />
    </ActionIcon>;

  const header = (
    <Stack
      py={16}
      gap={0}
      pos="sticky"
      top={0}
      style={{
        zIndex: 1
      }}
      bg="white"
    >
      <Group justify='space-between' align='start'>
        <Title order={5} maw='90%'> {title} </Title>
        {closeIcon}
      </Group>
      <Text size='sm' c={colors.gray[6]}> {subtitle} </Text>
    </Stack>
  );

  const footer = (
    <Group
      justify='space-between'
      py={16}
      pos="sticky"
      bottom={0}
      style={{
        zIndex: 1
      }}
      bg="white"
    >
      {(leftSideButton != null)
        ? <Button
          variant='subtle'
          disabled={leftSideButton.disabled ?? false}
          onClick={leftSideButton.onClick}
          color={leftSideButton.color}
        >
          {leftSideButton.label}
        </Button>
        : <Box />}
      <Group gap='md' >
        {
          (secondaryButton != null) &&
          <Button
            variant='subtle'
            disabled={secondaryButton.disabled ?? false}
            onClick={secondaryButton.onClick}
            color={secondaryButton.color}
          >
            {secondaryButton.label}
          </Button>
        }
        {
          (primaryButton != null) &&
          <Button
            disabled={primaryButton.disabled ?? false}
            onClick={primaryButton.onClick}
            color={primaryButton.color}
          >
            {primaryButton.label}
          </Button>
        }
      </Group>
    </Group>
  );

  return (
    <>
      <Stack mx={24} gap={0} mah='100%'>
        {header}
        <ScrollArea.Autosize style={{ display: 'flex', flexDirection: 'column' }} >
          {children}
        </ScrollArea.Autosize>
        {footer}
      </Stack >
    </>

  );
};

export default ModalContent;
